import { travelGuideQueryKeys as e } from "./travelGuideQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { travelGuidesApi as n } from "@maat/api-main";
//#region src/travelGuides/useTravelGuidesQuery.ts
var r = () => t({
	queryKey: e.list(),
	queryFn: () => n.list()
});
//#endregion
export { r as useTravelGuidesQuery };
